import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import flag from "../../../assets/images/Auditions/flag.png";
import flag4 from "../../../assets/images/Interval-01.1.png";
import flag2 from "../../../assets/images/Maximum-Time-01.1.png";
import vector from "../../../assets/images/meetupEvent/Vector.png";
import flag3 from "../../../assets/images/Minimum-Time-01.1.png";
import flag1 from "../../../assets/images/Registration-End-01.1.png";
import Countdown from "react-countdown";
import { serverInfo } from "../../../App";
import { useContext } from "react";
import ContdownTimerRender from "../../../HelperComponent/ContdownTimerRender";

const QnADetails = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();

  const [event, setEvent] = useState([]);
  const [availabilityStartTime, setAvailabilityStartTime] = useState([]);
  const [availabilityEndTime, setAvailabilityEndTime] = useState([]);
  const [slot, setSlot] = useState([]);

  const event_id = props.match.params.id;
  useEffect(() => {
    axios.get(`/api/star/qna_details/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data.event);
        setAvailabilityStartTime(res.data.event?.star_availability_start_date);
        setAvailabilityEndTime(res.data.event?.star_availability_end_date);
      }
    });
    axios.get(`/api/star/registeredList/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setSlot(res.data.users);
      }
    });
  }, [props.match.params.slug, history]);

  const handleClick = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/qna/approved/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.goBack();
        }
      });
    });
  };

  const setReject = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/qna/rejected/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.goBack()
        }
      });
    });
  };

  const joinQna = () => {
    history.push({
      pathname: "/superstar/qna/QnaMsgBox",
      state: { enrolldata: slot, slug: event_id, event: event, from: "star" },
    });
  };

  // new countdown
  // const auctionTime = moment(eventTime).format('LL HH:mm:ss')
  const startTime = moment(availabilityStartTime).format("LL HH:mm:ss");
  const endTime = moment(availabilityEndTime).format("LL HH:mm:ss");
  
  const countDownDate = new Date(startTime).getTime();
  const [timeStart, setTimeStart] = useState(false);
  
  const now = new Date().getTime();
  const countdownLabel = now < countDownDate ? "Starts in" : "Ends in";
  const countdownTime = now < countDownDate ? startTime : endTime;
  

  return (
    <>
      <div className="AS">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-12 col-lg-7  mb-3">
            {/* <div className="centered bg-warning">{countdownLabel}</div> */}
              <div className="card card-bg p-2 ">
                <img
                  src={imageCdnUrl + event.banner}
                  alt=""
                  className="img-fluid w-100 MeetUpPosition"
                />
                
                <Countdown
                  date={countdownTime}
                  renderer={ContdownTimerRender}
                />
              </div>
              <div className="centered bg-warning"></div>
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-md-12">
              <div className="card card-bg shadow">
                <div className="card-body">
                  <h5 className="text-light pb-3">{event.title}</h5>

                  <h5 className="text-warning">Instruction</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.instruction} />
                  </p>

                  <h5 className="text-warning">Description</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.description} />
                  </p>

                  <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                    <h5 className="text-warning pt-2">Star Availability</h5>
                    <p className="text-light fw-bold pt-2">
                      {moment(event.star_availability_start_date).format("LL")} - {moment(event.star_availability_end_date).format("LL")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row my-3 ">
            <div className="col-md-12">
              <div className=" shadow">
                <div className="registration-head  card-bg ">
                  <h5 className="text-warning fw-bold p-2">Registration </h5>
                </div>

                <div className="row registration-body  card-bg m-0 pt-3">
                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration Start:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {moment(event.registration_start_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag1} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration End:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {moment(event.registration_end_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag2} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">
                          Maximum Question Time:
                        </span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.max_time} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag3} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">
                          Minimum Question Time:
                        </span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.min_time} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Total Minutes:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.total_minutes} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Available Minutes:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.available_minutes} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration Fee:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          ${event.fee}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-md-12">
              <div className="card card-bg shadow">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="text-warning">Bundles</h5>
                  </div>
                  <div className="NotifyOver w-100 mb-5">
                    <table className="w-100 my-3 NotifyTabletd">
                      <thead style={{ borderBottom: "2px solid gold" }}>
                        <tr className="NotifyTable mx-3">
                          <td className="Notifytdx lNTS"> SL. </td>
                          <td className="Notifytdx"> Discount Percentage </td>
                          <td className="Notifytdx"> Minutes required </td>
                        </tr>
                      </thead>
                      <tbody>
                        {event?.bundles?.length > 0 ? (
                          event?.bundles?.map((bundle, index) => (
                            <tr className="NotifyTable mx-3" key={bundle.id}>
                              <td className="Notifytdx">{index + 1}</td>
                              <td className="Notifytdx">
                                {Number(bundle.percentage).toFixed(2) + "%"}
                              </td>
                              <td className="Notifytdx">{bundle.minutes}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              className="Notifytdx"
                              colSpan="4"
                              style={{ textAlign: "center", color: "white" }}
                            >
                              No bundles added yet by the admin
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-7 row mx-auto my-3">
              {Number(event.status) === 1 &&
                countDownDate <= new Date().getTime() ? (
                <div className="col-md-4 mb-3">
                  <div className="mt-3">
                    <button
                      className="btn btnJoinNow w-100 fw-bold px-5"
                      onClick={handleClick}
                    >
                      Join Now
                    </button>
                  </div>
                </div>
              ) : event.star_approval < 1 ? (
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <button
                      className="btn btnConfirm w-100 fw-bold"
                      onClick={handleClick}
                    >
                      Approved{" "}
                    </button>
                  </div>
                  <div className="col-md-4 mb-3">
                    <Link to={`/superstar/qna/edit/${event.id}`}>
                      <button className="btn btnEdit w-100 fw-bold">
                        Edit
                      </button>
                    </Link>
                  </div>
                  <div className="col-md-4 mb-3">
                    <button
                      className="btn btnDecline w-100 text-dark fw-bold"
                      onClick={setReject}
                    >
                      Reject
                    </button>
                  </div>
                </div>
              ) : event.star_id === event.created_by_id &&
                Number(event.status) < 1 ? (
                <div className="col-md-4 mx-auto mt-3">
                  <Link to={`/superstar/qna/edit/${event.id}`}>
                    <button className="btn btnEdit w-100 fw-bold px-3 mx-3">
                      Edit
                    </button>
                  </Link>
                </div>
              ) : Number(event.status) === 9 ? (
                <></>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>

      {Number(event.status) >= 1 ? (
        <div className="row my-3">
          <div className="col-md-12">
            <div className="card card-bg solt-card">
              <div className="card-body">
                <h3 className="text-warning">
                  <img src={vector} alt="clock" className="mx-2"></img>
                  Registered Users ({slot.length})
                </h3>
                <div className="row my-3">
                  {slot.map((user, index) => (
                    <div className="col-md-2 col-sm-3 ">
                      <p className="sold-small-card fw-bold text-ellipsis">
                        <img
                          src={imageCdnUrl + user.user?.image}
                          className="img-fluid mx-2 p-1"
                          alt=""
                          style={{ height: "50px", width: "50px" }}
                        />
                        {user.user?.first_name} {user.user?.last_name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {Number(event.status) === 2 &&
        (Date.now() >= new Date(startTime).getTime() && Date.now() <= new Date(endTime).getTime() ?
        <center className="mt-5 ">
          <button
            onClick={joinQna}
            className="btn btnJoinNow  fw-bold px-5 mx-2"
          >
            Join Now
          </button>
        </center>:null )
      }

    </>
  );
};

export default QnADetails;
